module.exports = __webpack_public_path__ + "static/media/Hamburger_Sprite_Sheet1.058355db.svg";